/*
 * @Author: your name
 * @Date: 2021-06-22 11:20:41
 * @LastEditTime: 2021-06-24 15:01:26
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /HR_FE/src/router/router.js
 */
/**
 * 全站路由配置
 *
 * meta参数说明
 * keepAlive是否缓冲页面
 * isTab是否加入到tag导航
 * isAuth是否需要授权
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import i18n from '@/libs/i18n' // Internationalization 国际化 多语言
import PageRouter from './page' // 页面路由
import ViewsRouter from './views' // 页面路由
import PublicRouter from './views/public' // 页面路由
import AvueRouter from './avue-router' // 封装的路由控制方法
import Store from '../store'
// vuex
Vue.use(VueRouter)

// 静态路由
const staticRouter = [...PageRouter, ...ViewsRouter, ...PublicRouter]
// 动态路由
const dynamicRouter = Store.state.user.menuAll

/** -------------------静态路由存储VUEX方便渲染菜单------------------- */
Store.dispatch('setStaticRouter', staticRouter)
console.log('+++++++++++++++++++++++++++++')

// 创建路由
export const createRouter = () => new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  // https://router.vuejs.org/zh/guide/advanced/scroll-behavior.html#%E5%BC%82%E6%AD%A5%E6%BB%9A%E5%8A%A8
  // 这个方法 是控制滚动条
  // 如果 retuen falsy || {} ,则不发生滚动
  scrollBehavior(to, from, savedPosition) {
    // savedPosition 这个参数当且仅当导航 (通过浏览器的 前进/后退 按钮触发) 时才可用  效果和 router.go() 或 router.back()
    if (savedPosition) {
      // 返回savedPosition 其实就是 当用户点击 返回的话，保持之前游览的高度
      return savedPosition
    }
    if (from.meta.keepAlive) {
      // eslint-disable-next-line no-param-reassign
      from.meta.savedPosition = document.body.scrollTop
    }
    return {
      x: 0,
      y: to.meta.savedPosition || 0,
    }
  },
  routes: staticRouter,
})

// 获得 route 实例
const router = createRouter()

/** --------------------------------------动态路由渲染-----------------------------------* */
AvueRouter.install(Vue, router, Store, i18n) // 初始化和注册 AvueRouter
router.$avueRouter.formatRoutes(dynamicRouter, true) // 动态路由核心方法
router.addRoutes(staticRouter)
export function resetRouter() { // 重置路由 比如用于身份验证失败，需要重新登录时 先清空当前的路有权限
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
  AvueRouter.install(Vue, router, Store, i18n)
}
/** --------------------------------------动态路由渲染-----------------------------------* */

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})
export default router
